module.exports = __webpack_public_path__ + "static/favicon-32x32.png";


//////////////////
// WEBPACK FOOTER
// ./src/examples/shared/favicon/favicon-32x32.png
// module id = 512
// module chunks = 0